import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Field, FormSection } from 'redux-form';
import { propArrayShape, propStr, } from '../../../../../helpers/custom-prop-types';
import { consultantValidate } from '../../../../../validate/custom/profile';
import CheckBoxListColumnComponent from '../Common/CheckBoxListColumnComponent';
import CheckBoxListParts from '../Common/CheckBoxListParts';
import ExperienceClassPartsOther from './ExperienceClassPartsOther';
const ExperienceClassParts = (props) => {
    const { experienceClasses, form } = props;
    const experienceClassesOtherId = useMemo(() => {
        const experienceClassesOther = experienceClasses.find(({ isOther }) => isOther) || {};
        return experienceClassesOther.id || null;
    }, [experienceClasses]);
    const renderOther = useCallback(({ isOtherCheck }) => (_jsx(FormSection, Object.assign({ name: `experienceClasses[${experienceClassesOtherId}]` }, { children: _jsx(Field, { component: ExperienceClassPartsOther, experienceClasses: experienceClasses, isDisabled: !isOtherCheck, name: 'other', validate: isOtherCheck ? consultantValidate.experienceClasses.other : [] }) }))), [experienceClasses, experienceClassesOtherId]);
    return (_jsx(CheckBoxListParts, { description: '過去、ご経験のある項目をご選択ください', descriptionClassName: 'pl1', form: form, label: '経験', lists: experienceClasses, maxCount: 0, name: 'experienceClasses', other: renderOther, otherId: experienceClassesOtherId, render: ({ isDisabled, row }) => (_jsx(CheckBoxListColumnComponent, { fieldName: 'check', id: row.id, isDisabled: isDisabled, lists: experienceClasses, name: 'experienceClasses' }, row.id)) }));
};
ExperienceClassParts.propTypes = {
    experienceClasses: propArrayShape().isRequired,
    form: propStr().isRequired,
};
export default ExperienceClassParts;
